import { useEffect, useRef } from "react";
import { FiX, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import PlaceholderImage from "./PlaceholderImage";
import "./Lightbox.css";

export default function Lightbox({ items, activeIndex, onClose, onPrev, onNext }) {
  const closeRef = useRef(null);
  const item = items[activeIndex];

  useEffect(() => {
    closeRef.current?.focus();
    document.body.style.overflow = "hidden";
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose, onPrev, onNext]);

  if (!item) return null;

  return (
    <div className="lightbox-overlay" role="presentation" onClick={onClose}>
      <div className="lightbox" role="dialog" aria-modal="true" aria-label={item.alt} onClick={(e) => e.stopPropagation()}>
        <button ref={closeRef} type="button" className="lightbox__close" onClick={onClose} aria-label="Close image viewer">
          <FiX aria-hidden="true" />
        </button>
        <button type="button" className="lightbox__nav lightbox__nav--prev" onClick={onPrev} aria-label="Previous image">
          <FiChevronLeft aria-hidden="true" />
        </button>
        <div className="lightbox__media">
          {/* <PlaceholderImage tone={item.tone} alt={item.alt} ratio="4/3" /> */}
          <img src={item.img} alt="" />
          {/* <p className="lightbox__caption">{item.alt}</p> */}
        </div>
        <button type="button" className="lightbox__nav lightbox__nav--next" onClick={onNext} aria-label="Next image">
          <FiChevronRight aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
